import { useRef } from 'react';
import SimpleReactValidator from 'simple-react-validator';

const UserValidator = () => {
     return useRef(new SimpleReactValidator({
        className: 'text-danger',
        validators: {
            usernameRequired: {
                message: 'Please enter an username.',
                rule: (val) => val !== undefined && val !== '',
                required: true,
            },
            usernameNoSpace: {
                message: 'Entity should not contain white spaces',
                rule: (val) => {
                    const pattern = /^\S*$/;
                    return pattern.test(val);
                }
            },
            firstnameRequired: {
                message: 'Please enter the First Name.',
                rule: (val) => val !== undefined && val !== '',
                required: true,
            },
            lastnameRequired: {
                message: 'Please enter the Last Name.',
                rule: (val) => val !== undefined && val !== '',
                required: true,
            },
            preferrednameRequired: {
                message: 'Please enter the Preferred Name.',
                rule: (val) => val !== undefined && val !== '',
                required: true,
            },
            phoneNoRequired: {
                message: 'Please enter the Phone Number.',
                rule: (val) => val !== undefined && val !== '',
                required: true
            },
            emailRequired: {
                message: 'Please enter an email address.',
                rule: (val) => val !== undefined && val !== '',
                required: true
            },
            fileNameValidation : {
                message: 'Filename should only contain letters, numbers, hyphens, underscores, parentheses, and spaces.',
                rule: (val) => {
                    const pattern = /^[a-zA-Z0-9-_() ]+$/;
                    return pattern.test(val);
                }
            }
        },
        messages: {
            email: 'Please enter a valid email address',
        },
    })).current;
    
}

export default UserValidator;
